import { jwtDecode } from "jwt-decode";

export interface Token {
  jti: string;
  id: string;
  type: string;
  exp: number;
  showToken: boolean;
}

export const createToken = (rawToken: any): Token | null => {
  try {
    const decoded = jwtDecode<Token>(rawToken.value);
    return {
      jti: decoded.jti,
      id: rawToken.id,
      type: rawToken.type,
      exp: decoded.exp,
      showToken: false,
    };
  } catch (exception) {
    console.error("Error parsing token:", exception);
    return null;
  }
};
